import { EntityDateField } from '../../common/EntityDateField';
import { EntitySampleDateRangeConfigurator, EntitySampleDateRangeValidator } from '../../common/EntitySampleDateRangeConfigurator';
export const EntityTimestampPlugin = {
    type: 'timestamp',
    edit: {
        field: EntityDateField
    },
    sampleData: {
        configurator: EntitySampleDateRangeConfigurator,
        defaultValue: () => ({ min: new Date(), max: new Date() }),
        validate: EntitySampleDateRangeValidator
    }
};
//# sourceMappingURL=EntityTimestampPlugin.js.map